/* eslint-disable react/prop-types, require-jsdoc */
import React, { Fragment, PureComponent } from 'react';
import styled from 'styled-components';
import ReactImageMagnify from 'react-image-magnify';

import Styles from './ParkingForm.Styles';
import ValidateButton from '../TicketsWhite/ValidateButton';
import Text from '../../base/Text';

import TicketInfo from '../TicketInfo';
import InputsField from '../../base/InputsFieldFlat';
import gettingData from '../../../assets/images/clock.gif';
import { getParkingStatus } from '../../../helpers/CartManager';
import purpleArrow from '../../../assets/images/purple_arrow.png';

const Row = styled.div`${Styles.row}`;
const Select = styled.select`${Styles.inputRounderSelect}`;
const InputsWrapper = styled.div`${Styles.inputsWrapper};`;
const LabelInput = styled(Text).attrs({ bold: true })`${Styles.labelInput}`;
const PurplePrice = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.purplePrice}`; // prettier-ignore
const PurpleUsd = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.purpleUsd}`; // prettier-ignore
const PriceContainer = styled.div`${Styles.priceContainer}`;
const ButtonContainer = styled.div`${Styles.buttonContainer}`;

/**
* TicketInfo component
* @returns {JSX.Element}
*/
class ParkingForm extends PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      zone: '',
      vehicle: '',
      price: 0.00,
      address: '',
      city: '',
      zipcode: '',
      loading: true,
      page: typeof window === 'undefined' ? 'home' : window.location.href.substring(window.location.href.lastIndexOf('/') + 1),
      zones: [],
      vehicles: [],
      pricing: []
    };
    console.log({ image: this.imageRef })
    this.backToHome = this.backToHome.bind(this);
    this.getPrice = this.getPrice.bind(this);
    this.locale = props.locale;
  }

  backToHome() {
    window.location.href = `/${this.locale}`;
  }

  getPrice() {
    const {
      zone,
      vehicle,
      pricing
    } = this.state;
    let price = 0.0;
    const zonePrice = pricing.filter(zprice => zprice.zone === zone)[0];
    if (!zonePrice) {
      this.setState({ price }); return;
    }
    const vehiclePrice = zonePrice.prices.filter(zprice => zprice.vehicleType === vehicle)[0];
    if (!vehiclePrice) {
      this.setState({ price }); return;
    }
    price = vehiclePrice.price;
    this.setState({ price });
  }

  async componentDidMount() {
    const priceConfig = await fetch(process.env.GATSBY_BASE_API + '/wheels/pricing/config');
    const pricingInfo = (await priceConfig.json()).data;
    console.log('pricintinfo', pricingInfo);

    if (!pricingInfo) return;
    this.setState({
      zones: pricingInfo.zones,
      vehicles: pricingInfo.vehicleTypes,
      pricing: pricingInfo.pricing,
      loading: false
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      zone, vehicle
    } = this.state;
    if (prevState.zone !== zone || prevState.vehicle !== vehicle) {
      this.getPrice();
    }
  }

  checkZip(zipCode) {
    const valid = /^\d+$/.test(zipCode);
    if (valid && zipCode.length >= 4) return 1;
    return 0;
  }

  checkCity(city) {
    const valid = /^[A-Za-z0-9 -]*$/.test(city);
    if (valid && city.length >= 4) return 1;
    return 0;
  }

  checkAddress(address) {
    if (address.length >= 5) return 1;
    return 0;
  }

  render() {
    const {
      locale,
      backToHome,
      translations,
      startDate,
      startDateHandler,
      endDate,
      endDateHandler,
      startTime,
      startTimeHandler,
      endTime,
      endTimeHandler,
      lot,
      lotHandler,
      ticketType,
      minDate,
      maxDate,
      callParkingApi,
      getParkingPrice,
      isCallingParkingApi,
      saveParkingInfo
    } = this.props;
    const {
      address,
      city,
      zipcode,
      zones,
      vehicle,
      zone,
      vehicles: vehicleTypes,
      price,
      page,
      cityStatus,
      zipcodeStatus,
      addressStatus
    } = this.state;
    const { imageRef } = this;
    const freedomPayStyles = {
      borderRadius: '0.25rem',
      borderWidth: '1px',
      borderStyle: 'solid',
      display: 'block',
      fontSize: '1rem',
      fontFamily: 'Arial, sans-serif',
      height: 'calc(2.25rem + 2px)',
      lineHeight: 1.5,
      padding: '0.375rem 0.75rem',
      backgroundColor: 'white',
      marginBottom: '1rem',
      width: '100%',
      outline: 'none',
    };

    return (
      <Fragment>
        <PurpleUsd>
          <img
            alt=""
            width="30px"
            height="20px"
            style={{ marginInline: 'auto', cursor: 'pointer', paddingRight: '10px' }}
            src={purpleArrow}
            locale={locale}
            onClick={backToHome}
          />
          {translations.confirmWheelsPage}
        </PurpleUsd>
        <Row>
          <div style={{display: 'flex', flexDirection: 'column', flex: 3 }}>
            <TicketInfo
              startDate={startDate}
              startDateHandler={startDateHandler}
              endDate={endDate}
              endDateHandler={endDateHandler}
              startTime={startTime}
              startTimeHandler={startTimeHandler}
              endTime={endTime}
              endTimeHanlder={endTimeHandler}
              lot={lot}
              locale={locale}
              lotHandler={lotHandler}
              ticketType={ticketType}
              selectorItem="Wheels"
              translations={translations}
              minDate={minDate}
              maxDate={maxDate}
              callParkingApi={callParkingApi}
              getParkingPrice={getParkingPrice}
              page={page}
            />
            <Row style={{marginTop: '0px', marginBottom: '0px' }}>
              <InputsWrapper style={{ flex: 1, marginTop: '10px' }}>
                <LabelInput>{locale === 'es' ? 'Vehículo' : 'Vehicle'}</LabelInput>
                <Select
                  value={vehicle}
                  onChange={(evt) => { this.setState({ vehicle: evt.target.value }); }}
                  style={page !== 'home' ? freedomPayStyles : {}}
                >
                  <option value="" key="empty" selected>{getParkingStatus && (locale === 'es' ? 'Seleccionar Vehículo' : 'Select Vehicle')}</option>
                  {vehicleTypes.map(i => (
                    <option key={i.id} value={i.id}>{i.name}</option>
                  ))}
                </Select>
              </InputsWrapper>
              <InputsWrapper style={{ flex: 1, marginTop: '10px' }}>
                <LabelInput>{locale === 'es' ? 'Zona' : 'Zone'}</LabelInput>
                <Select
                  value={zone}
                  onChange={(evt) => { this.setState({ zone: evt.target.value }); }}
                  style={page !== 'home' ? freedomPayStyles : {}}
                >
                  <option value="" key="empty" selected>{getParkingStatus && (locale === 'es' ? 'Seleccionar Zona' : 'Select Zone')}</option>
                  {zones.map(i => (
                    <option key={i.name} value={i.name}>{i.display}</option>
                  ))}
                </Select>
              </InputsWrapper>
            </Row>
            <Row style={{ marginTop: '0px', marginBottom: '0px' }}>
              <InputsWrapper style={{ flex: 1, marginTop: '10px' }}>
                <InputsField
                  placeHolder={locale === 'es' ? 'Introduzca Dirección' : 'Insert Address'}
                  label={locale === 'es' ? 'Dirección' : 'Address'}
                  labelWarn={`${locale === 'es' ? 'Dirección' : 'Address'}${city.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
                  className="col-12"
                  onChange={(evt) => { this.setState({ address: evt.target.value, addressStatus: this.checkAddress(evt.target.value) }); }}
                  value={address}
                  name="name"
                  status={addressStatus}
                  labelOnTop
                />
              </InputsWrapper>
            </Row>
            <Row style={{ marginTop: '0px', marginBottom: '0px' }}>
              <InputsWrapper style={{ flex: 8, marginTop: '10px' }}>
                <InputsField
                  placeHolder={locale === 'es' ? 'Introduzca Ciudad' : 'Insert City'}
                  label={locale === 'es' ? 'Ciudad' : 'City'}
                  labelWarn={`${locale === 'es' ? 'Ciudad' : 'City'}${city.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
                  className="col-12"
                  onChange={(evt) => { this.setState({ city: evt.target.value, cityStatus: this.checkCity(evt.target.value) }); }}
                  value={city}
                  name="name"
                  status={cityStatus}
                  labelOnTop
                />
              </InputsWrapper>
              <InputsWrapper style={{ flex: 2, marginTop: '10px' }}>
                <InputsField
                  placeHolder={locale === 'es' ? 'Introduzca C.P' : 'Insert Zip Code'}
                  label={locale === 'es' ? 'C.P.' : 'Zip Code'}
                  labelWarn={`${locale === 'es' ? 'C.P.' : 'Zip Code'}${zipcode.length === 0 ? translations.isIncomplete : translations.isInvalid}`}
                  className="col-12"
                  onChange={(evt) => { this.setState({ zipcode: evt.target.value, zipcodeStatus: this.checkZip(evt.target.value) }); }}
                  value={zipcode}
                  name="name"
                  status={zipcodeStatus}
                  labelOnTop
                />
              </InputsWrapper>
            </Row>
            <p style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
              {translations.wheelsDisclaimer}
            </p>
            {price > 0 &&
              <PriceContainer>
                <PurpleUsd>Total:</PurpleUsd>
                <div style={{ display: 'flex' }}><PurplePrice>{`$${price.toFixed(2)}`}</PurplePrice><PurpleUsd>USD</PurpleUsd></div>
                <Row>
                  <ButtonContainer>
                    <ValidateButton
                      disabled={!startDate || !startTime || !addressStatus || !cityStatus || !zipcodeStatus || !vehicle || !zone}
                      action={() => { saveParkingInfo({ type:'wheels', startDate, startTime, address, city, zipcode, vehicle, zone, price }); }}
                      message={translations.continueLabel}
                    />
                  </ButtonContainer>
                </Row>
              </PriceContainer>
            }
            {isCallingParkingApi && (
              <div
                style={{
                  padding: '5%',
                  width: '100%',
                  margin: 'auto',
                  justifyContent: 'center'
                }}
              >
                <img
                  alt=""
                  style={{ margin: 'auto', display: 'block' }}
                  width="150px"
                  height="auto"
                  src={gettingData}
                />
              </div>
            )}
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 2,
            height: 600,
          }}
          >
            <ReactImageMagnify
              enlargedImagePosition="over"
              smallImage={{ src: 'https://cbx-fe.s3.us-east-2.amazonaws.com/app/CBX-Map-Wheels.svg', width: 400, height: 600 }}
              largeImage={{ src: 'https://cbx-fe.s3.us-east-2.amazonaws.com/app/CBX-Map-Wheels.svg', width: 400 * 3, height: 600 * 3 }}
            />
          </div>
        </Row>
      </Fragment>
    );
  }
}


export default ParkingForm;
